export default "__VITE_ASSET__CMQIWsjC__"